// types
import type { SigninDataType } from '@dr-keyword-types/models/auth'

export const INITIAL_STATE: SigninDataType = { email: '', password: '' }
